import Big from 'big.js';
import _ from 'lodash';
import { DateTime } from 'luxon';



export type IDatum = {
  date: DateTime;
  value: Big;
};

export function extractValue<T extends object, K extends keyof T>({
  data, property
}: {
  data: T;
  property: K;
}) {
  const value = data[property];
  return value as typeof value;
}



function __getCurrentMonthAverage(data: IDatum[], anchorDate: DateTime) {
  const currentMonthData = __getAllDataSharingMonth(data, anchorDate);
  return __getAverage(currentMonthData);
}



function __getAverage(data: IDatum[]) {
  const sum = data.reduce((acc, datum) => acc.plus(datum.value), Big(0));
  return sum.div(data.length || 1);
}



function __getAllDataSharingMonth(data: IDatum[], date: DateTime) {
  return data.filter((datum) => (
    datum.date.month === date.month
    && datum.date.year === date.year
  ));
}



function __getPreviousYearEquivalentAverage(data: IDatum[], anchorDate: DateTime) {
  const previousDate = anchorDate.minus({
    years: 1
  });
  const monthData = __getAllDataSharingMonth(data, previousDate);
  return __getAverage(monthData);
}



export function getMonthOverMonthChange(data: IDatum[]) {
  const anchorDate = _.maxBy(data, (datum) => datum.date.toMillis())?.date;
  if (!anchorDate) {
    return Big(0);
  }

  const currentMonthAvg = __getCurrentMonthAverage(data, anchorDate);
  const previousMonthAvg = __getPreviousYearEquivalentAverage(data, anchorDate);

  const delta = currentMonthAvg.minus(previousMonthAvg);
  return previousMonthAvg.eq(0)
    ? delta.div(1)
    : delta.div(previousMonthAvg);
}



export function formatWithComma(value: number, decimalPlaces?: number): string {
  if (decimalPlaces) {
    return __convertToCommaFormat(_.round(value, decimalPlaces));
  }
  return __convertToCommaFormat(value);
}



function __convertToCommaFormat(value: number) {
  const strArr = value.toString().split('.');
  strArr[0] = strArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return strArr.join('.');
}

